import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function WhatsIncluded() {
  const stages = [{
    title: 'Briefing con el cliente',
    desc: 'Preguntas clave, criterios de búsqueda y acuerdos iniciales para no empezar con información incompleta.'
  }, {
    title: 'Diseño de la búsqueda',
    desc: 'Perfil ideal, filtros prioritarios, canales, palabras clave y estrategia antes de salir al mercado.'
  }, {
    title: 'Atracción y sourcing',
    desc: 'Dónde buscar candidatos, cómo contactarlos y cómo aplicar un primer filtro sin perder tiempo.'
  }, {
    title: 'Filtro y evaluación de CVs',
    desc: 'Sistema para clasificar candidatos, detectar señales de encaje y registrar motivos de avance o descarte.'
  }, {
    title: 'Entrevista de selección',
    desc: 'Protocolo estructurado para preguntar, profundizar, evaluar y registrar cada candidato.'
  }, {
    title: 'Presentación al cliente',
    desc: 'Cómo armar una terna profesional con fortalezas, dudas, condiciones y recomendación.'
  }, {
    title: 'Seguimiento y cierre',
    desc: 'Cómo gestionar feedback, oferta, candidatos descartados, cierre e histórico del proceso.'
  }];
  return <section className="py-24 bg-slate-50" data-id="element-148">
      <div className="max-w-4xl mx-auto px-6" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-slate-900 mb-6" data-id="element-151">
            QUÉ INCLUYE KIT RECRUITER PRO
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-152">
            Todo lo que necesitás para ordenar tus procesos de selección desde
            el primer contacto con el cliente hasta el cierre final de la
            búsqueda.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-10 shadow-xl shadow-slate-200/50 border border-slate-100 mb-16" data-id="element-153">
          <div className="flex items-start md:items-center gap-6 mb-8 pb-8 border-b border-slate-100 flex-col md:flex-row" data-id="element-154">
            <div className="w-16 h-16 bg-emerald-600 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg shadow-emerald-600/20" data-id="element-155">
              <BookOpen className="w-8 h-8 text-white" data-id="element-156" />
            </div>
            <div data-id="element-157">
              <h3 className="text-2xl font-display font-bold text-slate-900 mb-2" data-id="element-158">
                Guía Principal: KIT Recruiter PRO
              </h3>
              <p className="text-slate-600" data-id="element-159">
                El sistema completo para gestionar búsquedas activas con más
                claridad, estructura y velocidad.
              </p>
            </div>
          </div>

          <h4 className="text-xl font-bold text-slate-900 mb-8 flex items-center" data-id="element-160">
            Sistema Recruiter PRO™ en 7 etapas
          </h4>

          <div className="space-y-6" data-id="element-161">
            {stages.map((stage, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex gap-4 md:gap-6" data-id="element-162">
                <div className="flex flex-col items-center" data-id="element-163">
                  <div className="w-10 h-10 rounded-full bg-slate-100 text-slate-500 font-display font-bold flex items-center justify-center flex-shrink-0 text-sm border border-slate-200" data-id="element-164">
                    0{idx + 1}
                  </div>
                  {idx !== stages.length - 1 && <div className="w-px h-full bg-slate-200 mt-2" data-id="element-165"></div>}
                </div>
                <div className="pb-6" data-id="element-166">
                  <h5 className="text-lg font-bold text-slate-900 mb-1" data-id="element-167">
                    {stage.title}
                  </h5>
                  <p className="text-slate-600" data-id="element-168">{stage.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        <div className="text-center" data-id="element-169">
          <CTAButton size="large" data-id="element-170" />
        </div>
      </div>
    </section>;
}